
export const MATTER_VALUE_CHANGED = 'MATTER_VALUE_CHANGED'
export const CLIENT_OR_SUBJECT_OF_MATTER_VALUE_CHANGED = 'CLIENT_OR_SUBJECT_OF_MATTER_VALUE_CHANGED'
export const NUMBER_OF_CLIENTS_CHANGED = 'NUMBER_OF_CLIENTS_CHANGED'
export const NUMBER_OF_Opponents_CHANGED = 'NUMBER_OF_Opponents_CHANGED'

export const EXTRA_JUDICIAL_MATTERS_ACTIVATION_CHANGED = 'EXTRA_JUDICIAL_MATTERS_ACTIVATION_CHANGED'
export const NUMBER_OF_VALUE_ADDED_TAX_CHANGED = 'NUMBER_OF_VALUE_ADDED_TAX_CHANGED'
export const EXTRA_JUDICIAL_VV1000_CHANGED = 'EXTRA_JUDICIAL_VV1000_CHANGED'
export const EXTRA_JUDICIAL_VV1008_CHANGED = 'EXTRA_JUDICIAL_VV1008_CHANGED'
export const EXTRA_JUDICIAL_VV2300_CHANGED = 'EXTRA_JUDICIAL_VV2300_CHANGED'
export const EXTRA_JUDICIAL_VV7001_7002_CHANGED = 'EXTRA_JUDICIAL_VV7001_7002_CHANGED'
export const JUDICIAL_MATTERS_ACTIVATION_CHANGED = 'JUDICIAL_MATTERS_ACTIVATION_CHANGED'
export const JUDICIAL_VV1000_CHANGED = 'JUDICIAL_VV1000_CHANGED'
export const JUDICIAL_VV1008_CHANGED = 'JUDICIAL_VV1008_CHANGED'
export const JUDICIAL_VV3100_CHANGED = 'JUDICIAL_VV3100_CHANGED'
export const JUDICIAL_VV3104_CHANGED = 'JUDICIAL_VV3104_CHANGED'
export const JUDICIAL_ANRECHNUNG_CHANGED = 'JUDICAL_ANRECHNUNG_CHANGED'
export const JUDICIAL_VV7001_7002_CHANGED = 'JUDICIAL_VV7001_7002_CHANGED'
export const JUDICIAL_VV7000_7003_CHANGED = 'JUDICIAL_VV7000_7003_CHANGED'
export const UI_DRAWER_VISIBILITY_CHANGED = 'UI_DRAWER_VISIBILITY_CHANGED'


function makeActionCreator(type, ...argNames) {
    console.log(type)
  return function (...args) {
    let action = { type }
    argNames.forEach((arg, index) => {
      action[argNames[index]] = args[index]
    })
    return action
  }
}

export const changedMatterValue = makeActionCreator(MATTER_VALUE_CHANGED,  'payload');
export const changedClientOrSubjectOfMatter = makeActionCreator(CLIENT_OR_SUBJECT_OF_MATTER_VALUE_CHANGED,  'payload');
export const changedNumberOfClients = makeActionCreator(NUMBER_OF_CLIENTS_CHANGED,  'payload');
export const changedNumberOfOpponents = makeActionCreator(NUMBER_OF_Opponents_CHANGED,  'payload');

export const changedExtraJudicialMattersIsActive = makeActionCreator(EXTRA_JUDICIAL_MATTERS_ACTIVATION_CHANGED, 'payload');
export const changedValueAddedTax = makeActionCreator(NUMBER_OF_VALUE_ADDED_TAX_CHANGED,  'payload');
export const changedExtraJudicialVV7001_7002 = makeActionCreator(EXTRA_JUDICIAL_VV7001_7002_CHANGED, 'payload');
export const changedJudicialMattersIsActive = makeActionCreator(JUDICIAL_MATTERS_ACTIVATION_CHANGED, 'payload');
export const changedJudicialVV1000 = makeActionCreator(JUDICIAL_VV1000_CHANGED, 'payload');
export const changedJudicialVV1008 = makeActionCreator(JUDICIAL_VV1008_CHANGED, 'payload');
export const changedJudicialVV3100 = makeActionCreator(JUDICIAL_VV3100_CHANGED, 'payload');
export const changedJudicialVV3104 = makeActionCreator(JUDICIAL_VV3104_CHANGED, 'payload');
export const changedJudicialVV7001_7002 = makeActionCreator(JUDICIAL_VV7001_7002_CHANGED, 'payload');
export const changedJudicialVV7000_7003 = makeActionCreator(JUDICIAL_VV7000_7003_CHANGED, 'payload');
export const changedJudicialANRECHNUNG = makeActionCreator(JUDICIAL_ANRECHNUNG_CHANGED, 'payload');
export const changedUiDrawerVisibility = makeActionCreator(UI_DRAWER_VISIBILITY_CHANGED, 'visibility');


export function changedExtraJudicialVV(feeFactor, vvNumber) {
    console.log('EXTRA_JUDICIAL_'+ vvNumber +'_CHANGED' + feeFactor );
    return {
        type: 'EXTRA_JUDICIAL_'+ vvNumber +'_CHANGED',
        payload: feeFactor
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js